import React from 'react';

const AboutUs = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
       <h1 style={styles.title}>About Us</h1>

<p style={styles.paragraph}>
  <strong>
    Welcome to <a href="https://earthscan.example.com" style={styles.goldLink}>EarthScan®</a> Digital Geospatial Platform
  </strong>
</p>

<p style={styles.paragraph}>
  EarthScan® is a powerful digital geospatial platform that provides accurate, up-to-date satellite imagery and geospatial intelligence. Whether you're exploring areas of interest, monitoring environmental changes, or conducting spatial planning, EarthScan® empowers users with fast, accurate, and user-friendly tools to support informed decision-making.
</p>

<p style={styles.paragraph}>
  EarthScan® is proudly powered by <a href="https://sobekglobal.com" style={styles.goldLink}>SOBEK® Global</a>, a leading provider of geospatial, surveying, and remote sensing solutions. Backed by Sobek's technical expertise and commitment to innovation, EarthScan® is built to serve professionals, institutions, and decision-makers across sectors with world-class spatial capabilities.
</p>

        <h2 style={styles.subtitle}>Our Mission</h2>
        <p style={styles.paragraph}>To deliver accessible, accurate, and timely satellite imagery and geospatial intelligence, empowering users to make data-driven decisions that shape a smarter, more sustainable world.</p>

       <h2 style={styles.subtitle}>What We Offer</h2>
<div style={styles.gridTwoColumns}>
  <div style={styles.gridItem}>High-Resolution Satellite Imagery – Access the latest imagery for any location with pinpoint accuracy.</div>
  <div style={styles.gridItem}>Advanced Geospatial Tools – Perform change detection, spatial analysis, and visual monitoring with ease.</div>
  <div style={styles.gridItem}>Open Metadata Downloads – Instantly export key spatial files (Shapefile, KML, KMZ) for your area of interest.</div>
  <div style={styles.gridItem}>Custom Solutions & Support – Benefit from tailored services and expert support.</div>
  <div style={styles.gridItem}>User-Centered Interface – Designed for professionals and non-specialists alike — intuitive, fast, and effective.</div>
</div>

<h2 style={styles.subtitle}>Who We Serve</h2>
<div style={styles.gridTwoColumns}>
  <div style={styles.gridItem}>Urban Planning & Infrastructure</div>
  <div style={styles.gridItem}>Environmental & Coastal Monitoring</div>
  <div style={styles.gridItem}>Agriculture & Natural Resources</div>
  <div style={styles.gridItem}>Research & Academia</div>
  <div style={styles.gridItem}>Government & Policy</div>
  <div style={styles.gridItem}>Disaster Management & Emergency Response</div>
</div>


        <h2 style={styles.subtitle}>Join Us</h2>
        <p style={styles.paragraph}>Explore the future of spatial intelligence with EarthScan®. From high-level insights to day-to-day operations, we’re here to help you see more, know more, and do more — with confidence EarthScan® your window to the world.</p>
        <p style={styles.footer}>EarthScan® | Capture the World : From Space</p>
      </div>
<div style={styles.bottomFooter}>
  All rights reserved © by Sobek® Global
</div>

      
    </div>
  );
};

const styles = {
  page: {
  backgroundColor: '#111',
  color: '#fff',
  fontFamily: 'Arial, sans-serif',
  minHeight: '50vh',
  display: 'flex',
  flexDirection: 'column',


  },
 container: {
  maxWidth: '900px',
  margin: '0 auto',
  lineHeight: '1.8',
  flex: 1,
  padding: '60px 20px'
},

  title: {
    fontSize: '36px',
    marginBottom: '30px',
    color: '#C18429'
  },
  subtitle: {
    fontSize: '24px',
    marginTop: '30px',
    color: '#1ba99e'
  },
  paragraph: {
    fontSize: '16px',
    color: '#ccc',
    marginBottom: '20px',
    textAlign: 'justify'
  },
  list: {
    paddingLeft: '20px',
    color: '#ccc',
    marginBottom: '20px',
    fontSize: '16px'
  },
  footer: {
    marginTop: '40px',
    fontSize: '14px',
    color: '#999',
    textAlign: 'center'
  },
  bottomFooter: {
  backgroundColor: '#deb878', // لون ذهبي مشابه للصورة
  color: '#111',
  textAlign: 'center',
  padding: '10px 0',
  fontSize: '14px',
  fontFamily: 'Arial, sans-serif',
},
goldLink: {
  color: '#C18429', // نفس لون العنوان About Us
  textDecoration: 'none',
  fontWeight: 'bold'
},
gridTwoColumns: {
  display: 'flex',
  flexDirection: 'column',  // ← نعرض العناصر عموديًا
  gap: '10px',               // ← مسافة بين كل عنصر والتاني
  paddingLeft: '0px',        // ← محاذاة مثل الفقرات
},
gridItem: {
  fontSize: '16px',
  color: '#ccc',
  textAlign: 'justify',
  lineHeight: '1.8',
}




  
};

export default AboutUs;
